export const PRESSURE_STATES = {
    NOMINAL: 'nominal',
    FAIR: 'fair',
    SERIOUS: 'serious',
    CRITICAL: 'critical'
};
